import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:userProfile
 * @description
 * # userProfile
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'userProfile',
    ($http, ENV, $ngRedux, $scope, $rootScope, $location, $routeParams, $route, $timeout) => {
      if (!$scope.isAdminUser) {
        $location.path('/');
      }
      if (!Number.isInteger(Number($routeParams.userId))) {
        $location.path('/admin/users/manage-users/');
      }
      $rootScope.userId = $routeParams.userId;

      $scope.processParams = () =>
        new Promise((resolve) => {
          const {
            componentId,
            petId,
            petDetailId,
            redemptionId,
            transactionId,
            mediaId,
          } = $route.current.params;

          const components = [
            'create-pet',
            'submit-invoice',
            'redeem-points',
            'apply-user-activity',
            'point-history',
          ];

          if (components.includes(componentId)) {
            const type = componentId === 'apply-user-activity' ? 'apply-activity' : componentId;
            const componentOptions = {
              component: type,
            };
            $rootScope.openComponent(componentOptions);
            if (componentId === 'point-history') {
              $rootScope.onDisplayPoints($rootScope.userId);
            }
          }
          if (petId) {
            $scope.onEditPet({
              petId: petId,
              beforeRoute: `${$rootScope.routes.user}/${$rootScope.userId}/edit-pet/${petId}`,
            });
          }
          if (petDetailId) {
            $scope.onSelectPet({ petId: petDetailId });
          }
          if (redemptionId) {
            const beforeRoute = `${$rootScope.routes.user}/${$rootScope.userId}/redemption-detail/${redemptionId}`;
            const closeRoute = `${$rootScope.routes.user}/${$rootScope.userId}`;
            $scope.showRedemptionDetail({
              redemptionId: redemptionId,
              beforeRoute: beforeRoute,
              closeRoute: closeRoute,
            });
          }
          if (transactionId) {
            const beforeRoute = `${$rootScope.routes.user}/${$rootScope.userId}/transaction-detail/${transactionId}`;
            const closeRoute = `${$rootScope.routes.user}/${$rootScope.userId}`;
            $scope.showTransactionDetail({
              transactionId: transactionId,
              beforeRoute: beforeRoute,
              closeRoute: closeRoute,
            });
          }
          if (mediaId) {
            $scope.showMediaDetail({
              media: { id: mediaId },
              userId: $routeParams.userId,
            });
          }
          resolve(true);
        });

      $scope.reviewMedia = ({ media, userId }) => {
        $location.path(
          `/admin/users/manage-users/${$routeParams.userId}/media/${media[0].id}`,
          false,
        );
        $scope.showMediaDetail({ media: media, userId: $routeParams.userId });
      };

      $scope.createPointsHistoryRequest = (activityId) => {
        $scope
          .createPointsHistory($http, ENV, $rootScope.userId, activityId)
          .then(() => {
            $rootScope.getData();
            $scope.getLoyaltyStatistics($http, ENV, $rootScope.userId);
          })
          .catch((error) => {
            console.warn(error);
          });
      };

      $scope.generateOrganizationDetailLink = (organizationId, userId) => {
        return `${$rootScope.routes.user}/${userId}/organization-detail/${organizationId}`;
      };

      $scope.generatebeforeRoute = (type, id) => {
        return `${$rootScope.routes.user}/${$rootScope.userId}/${type}/${id}`;
      };

      $scope.generatecloseRoute = () => {
        return `${$rootScope.routes.user}/${$rootScope.userId}`;
      };

      $scope.reissuePointsRequest = (record) => {
        const data = {
          'user-activities': {
            reissue_points: true,
          },
        };
        $scope
          .reissueExpiredPoints($http, ENV, record.id, data)
          .then((response) => {
            $rootScope.showErrorModal = true;
            $rootScope.errorModalOptions = {
              heading: 'SUCCESS',
              message: `${response.num_points} points have been reissued.`,
              buttons: [
                {
                  label: 'OK',
                  href: '#',
                  clickFn: () => {
                    $rootScope.showErrorModal = false;
                  },
                },
              ],
            };
            $rootScope.getData();
          })
          .catch((error) => {
            const errors = error.data['user-activities'];
            $rootScope.errorModalOptions = {
              heading: 'ERROR',
              message: errors,
              buttons: [
                {
                  label: 'OK',
                  href: '#',
                  clickFn: () => {
                    $rootScope.showErrorModal = false;
                  },
                },
              ],
            };
            $timeout(() => {
              $rootScope.showErrorModal = true;
            }, 100);
          });
      };

      $scope.showReissuePointsConfirmModal = (record) => {
        var expireDate = new Date();
        expireDate.setMonth(expireDate.getMonth() + 15);
        const expiration = expireDate.toLocaleDateString();
        const amount = Number(record.num_points) < 0 ? record.num_points * -1 : record.num_points;
        $rootScope.showErrorModal = true;
        $rootScope.errorModalOptions = {
          heading: 'WARNING!',
          message: `Are you sure you want to re-issue ${amount} points to this user? These points will expire on ${expiration}`,
          buttons: [
            {
              label: 'OK',
              href: '#',
              clickFn: () => {
                $rootScope.showErrorModal = false;
                $scope.reissuePointsRequest(record);
              },
            },
            {
              label: 'Cancel',
              href: '#',
              clickFn: () => {
                $rootScope.showErrorModal = false;
              },
            },
          ],
        };
      };

      $scope.init = () => {
        $rootScope.previousRoute = `${$rootScope.routes.user}/${$rootScope.userId}`;
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
        $scope.processParams();
      };

      $scope.table = {
        name: 'User Activity',
        options: {
          endpoint: '/2.0/users/' + $rootScope.userId + '/user-activities/',
          endpoint_data_key: 'user-activities',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'activity',
          scale_up: true,
          search_key: null,
          id_prefix: 'userprofile',
          search_required: false,
          isMissingPoints: false,
        },
        actions: [],
        columns: [
          {
            name: 'Activity Date',
            options: {
              content: '{{ record.activity_date }}',
              class: '',
            },
          },
          {
            name: 'Activity Type',
            options: {
              content:
                '{{ ["Media", "Promotion Code", "Redemption", "Transaction", "Journey"].includes(record.activity_type) ? record.activity_type : record.activity_name }}' +
                '<br ng-if="record.activity_type == \'Journey\'" /><span ng-if="record.activity_type == \'Journey\'">Tracked:</span> <span ng-if="record.activity_type == \'Journey\'" class="bold italic">{{ record.activity.title }}</span>',
              class: '',
            },
          },
          {
            name: 'Activity Points',
            options: {
              content:
                '{{ record.num_points || 0 }}' +
                '<span ng-if="record.redemption && record.redemption.status.id < -2" class="bold italic pending">(pending)</span>' +
                '<span ng-if="record.transaction && record.transaction.status.id == 1" class="bold italic pending">(pending)</span>',
              class: '',
            },
          },
          {
            name: 'Additional Details',
            options: {
              content:
                '<div ng-if="record.media && record.media.length" class="media-additional-detail"><div class="media-id"><span class="bold italic">Media Count:</span> {{ record.media.length }}</div>' +
                '<div class="pet-info" ng-if="record.media.pets"><div class="italic">for</div><div ng-repeat="pet in record.media.pets"><a ng-click="onSelectPet({petId: pet.id})" href="#">{{ pet.name }}</a></div>' +
                '</div></div>' +
                '<div ng-if="record.redemption"><span class="bold italic">Redemption ID:</span> {{record.redemption.id }}</div>' +
                '<br><div ng-if="record.redemption && record.redemption.status"><span class="bold italic">Status:</span> <span ng-class="{ \'error\': record.redemption.status.name.match(\'Error\') !== null }">{{ record.redemption.status.name }}</span></div>' +
                '<div ng-if="record.transaction"><span class="bold italic">Transaction ID:</span> {{ record.transaction.id }}' +
                '<span class="bold italic" ng-if="record.transaction.status == 1">(submitted)</span></div>' +
                '<div ng-if="!record.transaction && !record.redemption && !record.media"><span class="bold italic">Activity ID:</span> {{ record.id }}</div>' +
                '<div ng-if="!record.transaction && !record.redemption && !record.media && record.user_activity_id"><span class="bold italic">User Activity ID:</span> {{ record.user_activity_id }}</div>' +
                '<div ng-if="record.user_responsible && record.user_responsible.id != record.user.id"><br /><strong style="font-weight:bold">User Responsible:</strong><br />{{ record.user_responsible.first_name }} {{ record.user_responsible.last_name }}<br />{{ record.user_responsible.contact_information.email }}</div>' +
                '<div ng-if="record.household && record.household.account_id">{{ record.household.account_id }}</div>',
              class: '',
            },
          },
          {
            name: 'Notes',
            options: {
              content:
                // '<div ng-if="record.activity_type == \'Journey\'" class="detail-content"><div><a href="#" ng-click="showJourneyDetail(record)">View Journey Details</a></div></div>' +
                '<div ng-if="record.media" class="detail-content"><div><a href="#" ng-click="reviewMedia({media: record.media, userId: record.media[0].user.id})">View Media Details</a></div></div>' +
                '<div ng-if="record.activity_type == \'Promotion Code\'" >{{ record.activity_name }}<br />{{ record.activity_description }}</div>' +
                '<div ng-if="record.redemption" ><a href="#" ng-click="showRedemptionDetail({redemptionId: record.redemption.id, beforeRoute: generatebeforeRoute(\'redemption-detail\', record.redemption.id), closeRoute: generatecloseRoute()})">View Redemption Details</a></div>' +
                '<div ng-if="record.transaction" ><a href="#" ng-click="showTransactionDetail({transactionId: record.transaction.id, beforeRoute: generatebeforeRoute(\'transaction-detail\', record.transaction.id), closeRoute: generatecloseRoute()})">View Transaction Details</a></div>' +
                '<div ng-if="!record.transaction && !record.redemption && !record.media" class="default-note">{{ record.notes }}</div>' +
                '<div ng-if="record.pet && record.pet.id" class="detail-content"><div><a href="#" ng-click="onSelectPet({petId: record.pet.id})">View Pet Details</a></div></div>' +
                `<div ng-if="record.organization && record.organization.id" class="detail-content"><div><a href="#" ng-click="onEditOrganization({organizationId: record.organization.id, beforeRoute: generateOrganizationDetailLink(record.organization.id, record.user.id)})">View Organization Details</a></div></div>` +
                '<div ng-if="table.options.isMissingPoints" class="detail-content"><br /><div><a href="#" ng-click="createPointsHistoryRequest(record.id)">Create Missing Point History</a></div></div>' +
                '<div ng-if="record.activity_name === \'expired points\'" class="default-note"><a href="#" ng-click="showReissuePointsConfirmModal(record)">Reissue Points</a></div>',
              class: '',
            },
          },
        ],
        filters: [
          {
            name: 'Activity Types',
            type: 'multiple_choice',
            options: {
              choices: {
                Media: { state: true, value: 'media', order: 0 },
                'Promotion Codes': { state: true, value: 'promotion_codes', order: 1 },
                Transactions: { state: true, value: 'transactions', order: 2 },
                Redemptions: { state: true, value: 'redemptions', order: 3 },
                Journeys: { state: true, value: 'journey', order: 4 },
                'Member Tiers': { state: true, value: 'member_tier', order: 5 },
                'Other Point-Based Activities': {
                  state: true,
                  value: 'other_point_based_activities',
                  order: 6,
                },
                Other: { state: true, value: 'other', order: 7 },
              },
              class: 'activity-type-filter',
              query_string_parameter: 'data_type',
              select_all: true,
            },
          },
          {
            name: 'Point Adjustments',
            type: 'single_choice',
            options: {
              choices: {
                All: { type: 'standard', state: true, value: 'all', order: 0 },
                'Only Adjustments': {
                  type: 'standard',
                  state: false,
                  value: 'adjustments',
                  order: 1,
                },
                'Only Credits': { type: 'standard', state: false, value: 'credits', order: 2 },
                'Only Debits': { type: 'standard', state: false, value: 'debits', order: 3 },
                'Custom Amount': {
                  type: 'amount',
                  state: false,
                  value: 'amount',
                  amount: '',
                  date_field: false,
                  order: 4,
                  error: false,
                },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: false,
                  order: 5,
                  error: false,
                },
              },
              class: 'point-adjustments-filter',
              query_string_parameter: 'point_adjustment',
            },
          },
          {
            name: 'Timeframe',
            type: 'single_choice',
            options: {
              choices: {
                'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
                'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
                'Previous 365 Days': { type: 'standard', state: true, value: 'year', order: 2 },
                All: { type: 'standard', state: false, value: 'all', order: 3 },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: true,
                  order: 4,
                  error: false,
                },
              },
              class: 'timeframe-filter',
              query_string_parameter: 'timeframe',
            },
          },
          {
            name: 'Other',
            type: 'single_choice',
            options: {
              choices: {
                All: { type: 'standard', state: true, value: 'all', order: 0 },
                'Transactions with Unapplied Promotion Codes': {
                  type: 'standard',
                  state: false,
                  value: 'transactions_unapplied_codes',
                  order: 1,
                },
                'Incomplete/Errored Transactions': {
                  type: 'standard',
                  state: false,
                  value: 'transactions_errored',
                  order: 2,
                },
                'Incomplete/Errored Redemptions': {
                  type: 'standard',
                  state: false,
                  value: 'redemptions_errored',
                  order: 3,
                },
              },
              class: 'other-filter above-divider',
              query_string_parameter: 'other_filters',
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Missing Points History',
            type: 'multiple_choice',
            options: {
              choices: {
                'Only Missing Points History Activities': { state: false, value: 1, order: 0 },
              },
              class: 'above-divider',
              query_string_parameter: 'missing_points',
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Activity Status',
            type: 'multiple_choice',
            options: {
              choices: {},
              choices_endpoint: '/2.0/user-activities/statuses/?paginate=false',
              choices_endpoint_data_key: 'user-activity-statuses',
              class: 'scroll-choices above-divider',
              name_attribute: 'name',
              no_selected_parameter: 'none',
              query_string_parameter: 'status',
              select_all: true,
            },
          },
        ],
        sort_options: {
          activity_date: {
            state: true,
            value: '-1',
            title: 'Activity Date',
            order: 0,
          },
          data_type: {
            state: false,
            value: '1',
            title: 'Activity Type',
            order: 1,
          },
          num_points: {
            state: false,
            value: '1',
            title: 'Activity Points',
            order: 2,
          },
        },
      };

      $scope.init();
      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        if (!$rootScope.isUserPage) {
          $rootScope.userId = null;
          $scope.userInfo = [];
          $scope.user = {};
          $scope.pets = [];
          $scope.mediaId = null;
          $scope.setActiveMedia(null);
          $scope.setActiveJourney(null);
          $scope.setActiveUser({});
          $scope.setActiveUserInfo([]);
        }
      });
    },
  );
